import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import ColouredText from '../../components/ColouredText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { descriptionTypes } from './PlayerDescriptionEditor';
import { Tooltip as ReactTooltip } from 'react-tooltip'

const PlayerDescriptionEntry = ({ descriptionType, defaultUsername, descriptionEntry, updateEntry, deleteEntry, selectActiveDescription }) => {


    const [playerName, setPlayerName] = useState('');
    const [entry, setEntry] = useState(undefined);
    const [description, setDescription] = useState('');

    useEffect(() => {
        setPlayerName(defaultUsername);
        setEntry(descriptionEntry);
        setDescription(descriptionEntry.descriptionValue);

    }, [defaultUsername, descriptionEntry]);


    const deleteDescription = () => {
        if (window.confirm(`Are you sure you wish to delete ${entry.descriptionId} description?`)) {
            deleteEntry(entry);
        }
    }

    const commitDescription = () => {
        console.log(description);
        entry.descriptionValue = description;
        if (window.confirm('Are you sure you wish to update this description?')) {
            updateEntry(entry);
        }
    }

    const useDescription = () => {
        selectActiveDescription(entry.descriptionId);
    }

    const undoChanges = () => {
        setDescription(entry.descriptionValue);
    }

    const handleChange = (e) => {
        console.log(e.target.value);
        setDescription(e.target.value);
    }


    const getType = () => {
        return <small> ({descriptionTypes[descriptionType]})</small>
    }

    if (entry == undefined)
        return null;

    let textRows = 2;
    if (descriptionType > 0)
        textRows = 12;

    return (
        <Card className={"m-4 p-1"} >

            <ReactTooltip id="tooltipUndoChanges" place="bottom" effect="solid">
                Undo Changes to Item
            </ReactTooltip>
            <ReactTooltip id="tooltipSaveChanges" place="bottom" effect="solid">
                Save Changes to Item
            </ReactTooltip>
            <ReactTooltip id="tooltipDelete" place="bottom" effect="solid">
                Delete Item
            </ReactTooltip>
            <ReactTooltip id="tooltipUse" place="bottom" effect="solid">
                Use Description
            </ReactTooltip>

            <Row className="row fluid align-content-center py-2">
                <Col>
                    <h4>{entry.descriptionId} {getType()}</h4>
                </Col>
                <Col>
                    <FontAwesomeIcon onClick={useDescription} className="px-3 fa fa-lg fa-eom" icon={"portrait"} data-tip data-tooltip-id="tooltipUse" />
                    <FontAwesomeIcon onClick={commitDescription} className="px-3 fa fa-lg fa-eom" icon={"check-circle"} data-tip data-tooltip-id="tooltipSaveChanges"/>
                    <FontAwesomeIcon onClick={undoChanges} className="px-3 fa fa-lg fa-eom" icon={"undo"} data-tip data-tooltip-id="tooltipUndoChanges"/>
                    <FontAwesomeIcon onClick={deleteDescription} className="px-3 fa fa-lg fa-eom" icon={"trash-alt"} data-tip data-tooltip-id="tooltipDelete"/>
                </Col>
            </Row>

            <Row>
                <Col xs lg="2">
                    <span>Description</span>
                </Col>
                <Col lg>
                    <ColouredText ColouredText={description} />
                </Col>


            </Row>

            <Row>
                <Col xs lg="2">
                    <span>Enter Raw Text</span>
                </Col>
                <Col lg>
                    <textarea className="eomEditor my-2 p-2 eom-box" value={description} onChange={e => handleChange(e)} rows={textRows}></textarea>
                </Col>
            </Row>
        </Card>
    );

}

export default PlayerDescriptionEntry;